import { Center, Loader } from '@mantine/core';
import { FC, PropsWithChildren } from 'react';

interface LoaderWithChildrenProps extends PropsWithChildren {
  isLoading: boolean;
}

export const LoaderWithChildren: FC<LoaderWithChildrenProps> = ({
  isLoading,
  children,
}) => {
  if (isLoading) {
    return (
      <Center p="xl">
        <Loader />
      </Center>
    );
  }

  return children;
};
